module.exports = __webpack_public_path__ + "img/shinoosaka_marubiru.0fe13bd3.jpg";